import { render, staticRenderFns } from "./YamlEditor.vue?vue&type=template&id=fd5f8bd4&scoped=true&"
import script from "./YamlEditor.vue?vue&type=script&lang=js&"
export * from "./YamlEditor.vue?vue&type=script&lang=js&"
import style0 from "./YamlEditor.vue?vue&type=style&index=0&id=fd5f8bd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5f8bd4",
  null
  
)

export default component.exports